export const HEADER_HEIGHT = 56;
export const FOOTER_HEIGHT = 176;
export const FULL_CONTENT_HEIGHT = `calc(100vh - ${HEADER_HEIGHT + FOOTER_HEIGHT}px)`;
export const DESKTOP_WIDTH = 1136;
